/* eslint-disable max-len */
import { managementTypes } from '../types/management.types';

const initState = {
  managementTypes: {
    entry: [],
    loading: false,
    message: ''
  },
  managementCaseTypes: {
    entry: [],
    loading: false,
    message: ''
  },
  managements: {
    entry: [],
    loading: false,
    message: ''
  },
  caseManagements: {
    entry: [],
    loading: false,
    message: ''
  },
  management: {
    entry: null,
    loading: false,
    message: ''
  },
  managementCreated: {
    entry: null,
    loading: false,
    message: ''
  },
  managementCaseCreated: {
    entry: null,
    loading: false,
    message: ''
  },
  contactTypes: {
    entry: [],
    loading: false,
    message: ''
  },
  tracking: {
    entry: [],
    loading: false,
    message: ''
  },
  searchState: {
    entry: [],
    loading: false,
    message: ''
  },
  reasons: {
    data: [],
    loading: false,
    message: ''
  },
  closeReasons: {
    data: [],
    loading: false,
    message: ''
  },
};

const managementReducer = (state = initState, action) => {
  switch (action.type) {
    case managementTypes.GET_MANAGEMENT_TYPES:
      return { ...state, managementTypes: { ...state.managementTypes, loading: true } };
    case managementTypes.GET_MANAGEMENT_TYPES_SUCCESS:
      return {
        ...state,
        managementTypes: {
          ...state.managementTypes,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_MANAGEMENT_TYPES_FAILED:
      return {
        ...state,
        managementTypes: {
          ...state.managementTypes,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_CASE_MANAGEMENT_TYPES:
      return { ...state, managementCaseTypes: { ...state.managementCaseTypes, loading: true } };
    case managementTypes.GET_CASE_MANAGEMENT_TYPES_SUCCESS:
      return {
        ...state,
        managementCaseTypes: {
          ...state.managementCaseTypes,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_CASE_MANAGEMENT_TYPES_FAILED:
      return {
        ...state,
        managementCaseTypes: {
          ...state.managementCaseTypes,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_ALL_MANAGEMENTS:
      return { ...state, managements: { ...state.managements, loading: true, error: '' } };
    case managementTypes.GET_ALL_MANAGEMENTS_SUCCESS:
      return {
        ...state,
        managements: {
          ...state.managements,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_ALL_MANAGEMENTS_FAILED:
      return {
        ...state,
        managements: {
          ...state.managements,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_CASE_MANAGEMENTS:
      return { ...state, caseManagements: { ...state.caseManagements, loading: true, error: '' } };
    case managementTypes.GET_CASE_MANAGEMENTS_SUCCESS:
      return {
        ...state,
        caseManagements: {
          ...state.caseManagements,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_CASE_MANAGEMENTS_FAILED:
      return {
        ...state,
        caseManagements: {
          ...state.caseManagements,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.RESET_ALL_MANAGEMENTS:
      return {
        ...state,
        managements: {
          entry: [],
          loading: false,
        }
      };
    case managementTypes.RESET_CASE_MANAGEMENTS:
      return {
        ...state,
        caseManagements: {
          entry: [],
          loading: false,
        }
      };
    case managementTypes.GET_MANAGEMENT_REQUEST:
      return { ...state, management: { ...state.management, loading: true } };
    case managementTypes.GET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        management: {
          ...state.management,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_MANAGEMENT_FAILED:
      return {
        ...state,
        management: {
          ...state.management,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.POST_MANAGEMENT_REQUEST:
      return { ...state, managementCreated: { ...state.managementCreated, loading: true } };
    case managementTypes.POST_MANAGEMENT_SUCCESS:
      return {
        ...state,
        managementCreated: {
          ...state.managementCreated,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.POST_MANAGEMENT_FAILED:
      return {
        ...state,
        managementCreated: {
          ...state.managementCreated,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.POST_CASE_MANAGEMENT_REQUEST:
      return { ...state, managementCaseCreated: { ...state.managementCaseCreated, loading: true } };
    case managementTypes.POST_CASE_MANAGEMENT_SUCCESS:
      return {
        ...state,
        managementCaseCreated: {
          ...state.managementCaseCreated,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.POST_CASE_MANAGEMENT_FAILED:
      return {
        ...state,
        managementCaseCreated: {
          ...state.managementCaseCreated,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_CONTACT_TYPES:
      return { ...state, contactTypes: { ...state.contactTypes, loading: true } };
    case managementTypes.GET_CONTACT_TYPES_SUCCESS:
      return {
        ...state,
        contactTypes: {
          ...state.contactTypes,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_CONTACT_TYPES_FAILED:
      return {
        ...state,
        contactTypes: {
          ...state.contactTypes,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_TRACKING_REQUEST:
      return { ...state, tracking: { ...state.tracking, loading: true } };
    case managementTypes.GET_TRACKING_SUCCESS:
      return {
        ...state,
        tracking: {
          ...state.tracking,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_TRACKING_FAILED:
      return {
        ...state,
        tracking: {
          ...state.tracking,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_SEARCH_STATE_REQUEST:
      return { ...state, searchState: { ...state.searchState, loading: true } };
    case managementTypes.GET_SEARCH_STATE_SUCCESS:
      return {
        ...state,
        searchState: {
          ...state.searchState,
          loading: false,
          entry: action.payload.body
        }
      };
    case managementTypes.GET_SEARCH_STATE_FAILED:
      return {
        ...state,
        searchState: {
          ...state.searchState,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_REASON_REQUEST:
      return { ...state, reasons: { ...state.reasons, loading: true } };
    case managementTypes.GET_REASON_SUCCESS:
      return {
        ...state,
        reasons: {
          ...state.reasons,
          loading: false,
          data: action.payload.body
        }
      };
    case managementTypes.GET_REASON_FAILED:
      return {
        ...state,
        reasons: {
          ...state.reasons,
          loading: false,
          error: action.payload.error
        }
      };
    case managementTypes.GET_CLOSE_REASON_REQUEST:
      return { ...state, closeReasons: { ...state.closeReasons, loading: true } };
    case managementTypes.GET_CLOSE_REASON_SUCCESS:
      return {
        ...state,
        closeReasons: {
          ...state.closeReasons,
          loading: false,
          data: action.payload.body
        }
      };
    case managementTypes.GET_CLOSE_REASON_FAILED:
      return {
        ...state,
        closeReasons: {
          ...state.closeReasons,
          loading: false,
          error: action.payload.error
        }
      };
    default:
      return state;
  }
};

export default managementReducer;